import { Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import * as Yup from "yup"
import { BusinessDetailsType } from "../../../types/sellerType";
import { useAppDispatch } from "../../../State/Store";
import { updateSellerAccount } from "../../../State/seller/sellerSlice";
interface businessDetailsProp {
  businessDetails:BusinessDetailsType|null,
  gstin:string
} 
const BusinessEditFormSchema = Yup.object().shape({
  businessName: Yup.string().required("Business Name is required"),
  gstin: Yup.string().required("GSTIN is required"),
})
export const BusinessDetails = (data:businessDetailsProp) => {
  const dispatch = useAppDispatch()
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      businessName: data.businessDetails?.businessName??"",
      gstin: data.gstin??"",
    },
    validationSchema:BusinessEditFormSchema,
    onSubmit:async (values) => {

     await dispatch(updateSellerAccount({businessDetails:{businessName:values.businessName},gstin:values.gstin})).unwrap()
    },
  });

  return (
    <form className="space-y-4">
      <TextField
        fullWidth
        name="businessName"
        label="Business Name"
        value={formik.values.businessName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.businessName && Boolean(formik.errors.businessName)
        }
        helperText={formik.touched.businessName && formik.errors.businessName}
      />
      <TextField
        fullWidth
        name="gstin"
        label="GSTIN"
        value={formik.values.gstin}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.gstin && Boolean(formik.errors.gstin)}
        helperText={formik.touched.gstin && formik.errors.gstin}
      />
      <Button fullWidth variant="contained" type="submit" onClick={(e) => { e.preventDefault();formik.handleSubmit() }}>
        Submit
      </Button>
    </form>
  );
};
